import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

export const uploadDocuments = createAsyncThunk(
  "community/uploadDocuments",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/documents/",
        formData,
        {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            // Dispatch progress through a custom event
            window.dispatchEvent(
              new CustomEvent("upload-progress", {
                detail: { progress: percentCompleted },
              })
            );
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const getDocTypeApi = createAsyncThunk(
  "community/getDocTypeApi",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/community/community_doc_Type/"
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const getAllDocuments = createAsyncThunk(
  "community/getAllDocuments",
  async ({ community_id, access, page, page_size, search, user_id ,sortBy,sortOrder}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/documents/", {
        params: {
          community_id,
          access: access,
          page: page,
          page_size: page_size,
          search: search,
          user_id: user_id,
          sort_by: sortBy,
          sort_order: sortOrder,

        },
      });
      return { access, data: response.data.data };
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteDocumentData = createAsyncThunk(
  "community/deleteDocumentData",
  async (documentId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/community/documents/${documentId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const updateDocumentApi = createAsyncThunk(
  "community/updateDocumentApi",
  async ({ formData, document_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/community/documents/${document_id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateDocumentNameApi = createAsyncThunk(
  "community/updateDocumentApi",
  async ({ document_id, document_name, doc_type, community_id, user_id, documents }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        "/community/documents/",
        {
          document_id: document_id,
          document_name: document_name,
          doc_type: doc_type,
          community_id: community_id,
          user_id: user_id,
          documents: documents,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchDocumentById = createAsyncThunk(
  "community/fetchDocumentById",
  async (documentId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/documents/${documentId}/`);
      return response.data;
    } catch (error) {
      // Handle errors appropriately
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

// background task status
export const fetchTaskStatus = createAsyncThunk(
  "community/fetchTaskStatus",
  async (taskId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/task-status/${taskId}`);
      return response.data;
    } catch (error) {
      // Handle errors appropriately
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

export const fetchInsuranceTaskStatus = createAsyncThunk(
  "community/fetchInsuranceTaskStatus",
  async (taskId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/community/task-status/${taskId}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

export const fetchFinanceTaskStatus = createAsyncThunk(
  "community/fetchFinanceTaskStatus",
  async (taskId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/community/task-status/${taskId}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

export const updateDocumentDate = createAsyncThunk(
  "community/updateDocumentDate",
  async ({ community_id, user_id, documents }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        "/community/documents/",
        {
          community_id: community_id,
          user_id: user_id,
          documents: documents,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const syncRules = createAsyncThunk(
  "community/syncRules",
  async ({ id, name, community_id, version_date }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        "/community/documents-in-sync",
        {
          id: id,
          name: name,
          community_id: community_id,
          version_date: version_date
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);